import WaterInsightsSeries from '../enums/WaterInsightsSeries';

export default function waterInsightsSeriesTitle(series: string): string {

    switch(series) {

        case WaterInsightsSeries.S3CHL: return 'S3-CHL';
        case WaterInsightsSeries.S3TSM: return 'S3-TSM';
        case WaterInsightsSeries.SST_GHRSST: return 'SST-GHRSST';
        default: return '-';
    }
}
